import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-freeze-confirmation-dialog',
  templateUrl: './freeze-confirmation-dialog.component.html',
  styleUrls: ['./freeze-confirmation-dialog.component.scss']
})
export class FreezeConfirmationDialogComponent implements OnInit {
  freezedAmount = null;
  reference = null;
  action = null;
  operation = null
  constructor(  
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FreezeConfirmationDialogComponent>
  ) {
      this.operation = data.operation;
      this.action = data.action;
   }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }

  confirmDelete() {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/freeze-confirmation-dialog/freeze-confirmation-dialog.component.ts